import { Image, TooltipContent } from '../../../shared/shared.interface';

export interface Accordion {
  state: AccordionState;
}
export interface AccordionState {
  id?: string;
  title: string;
  isCollapsed: boolean;
  accordion: boolean;
  icon: Image;
  isTooltipPresent?: boolean;
  tooltip?: TooltipContent;
  tooltipClass?: string;
  isSearchFieldPresent?: boolean;
  searchFieldLabels?: SearchFieldLabels;
}

export interface SearchFieldLabels {
  search: {
    placeholder: string;
    icon: Image;
  };
  invalidSearchText: string;
}
